module.exports = "/dist/assets/images/checkbox.svg";